/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ContractMedications } from './ContractMedications';
import {
    ContractMedicationsFromJSON,
    ContractMedicationsFromJSONTyped,
    ContractMedicationsToJSON,
    ContractMedicationsToJSONTyped,
} from './ContractMedications';
import type { ContractRubric } from './ContractRubric';
import {
    ContractRubricFromJSON,
    ContractRubricFromJSONTyped,
    ContractRubricToJSON,
    ContractRubricToJSONTyped,
} from './ContractRubric';

/**
 * 
 * @export
 * @interface StructuredContract
 */
export interface StructuredContract {
    /**
     * 
     */
    subtype: StructuredContractSubtypeEnum;
    /**
     * 
     */
    rubrics: Array<ContractRubric>;
    /**
     * 
     */
    medications: ContractMedications;
    /**
     * 
     */
    equipment: Array<string>;
    /**
     * 
     */
    other_exceptions: Array<string>;
}


/**
 * @export
 */
export const StructuredContractSubtypeEnum = {
    Tiers: 'tiers',
    Categories: 'categories',
} as const;
export type StructuredContractSubtypeEnum = typeof StructuredContractSubtypeEnum[keyof typeof StructuredContractSubtypeEnum];


/**
 * Check if a given object implements the StructuredContract interface.
 */
export function instanceOfStructuredContract(value: object): value is StructuredContract {
    if (!('subtype' in value) || value['subtype'] === undefined) return false;
    if (!('rubrics' in value) || value['rubrics'] === undefined) return false;
    if (!('medications' in value) || value['medications'] === undefined) return false;
    if (!('equipment' in value) || value['equipment'] === undefined) return false;
    if (!('other_exceptions' in value) || value['other_exceptions'] === undefined) return false;
    return true;
}

export function StructuredContractFromJSON(json: any): StructuredContract {
    return StructuredContractFromJSONTyped(json, false);
}

export function StructuredContractFromJSONTyped(json: any, ignoreDiscriminator: boolean): StructuredContract {
    if (json == null) {
        return json;
    }
    return {
        
        'subtype': json['subtype'],
        'rubrics': ((json['rubrics'] as Array<any>).map(ContractRubricFromJSON)),
        'medications': ContractMedicationsFromJSON(json['medications']),
        'equipment': json['equipment'],
        'other_exceptions': json['other_exceptions'],
    };
}

export function StructuredContractToJSON(json: any): StructuredContract {
    return StructuredContractToJSONTyped(json, false);
}

export function StructuredContractToJSONTyped(value?: StructuredContract | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'subtype': value['subtype'],
        'rubrics': ((value['rubrics'] as Array<any>).map(ContractRubricToJSON)),
        'medications': ContractMedicationsToJSON(value['medications']),
        'equipment': value['equipment'],
        'other_exceptions': value['other_exceptions'],
    };
}

